import { ECalculatorErrorField, TCalculatorError, TCommonDataObj, TWAction } from '@libs/types';
import { TConsumerItem } from '../../../types/data';
import { ActionNameEnum, TErrorsResult, TResult } from './types';

export const getDataValueFromWidget = (value: TCommonDataObj) => {
    const fromInputValue = value?.fromInput ?? '0';
    const toInputValue = value?.toInput ?? '0';
    const fromCurrencyValue = value?.fromCurrency ?? '';
    const toCurrencyValue = value?.toCurrency ?? '';
    const codeValue = value?.code ?? '';
    return {
        fromInputValue,
        toInputValue,
        fromCurrencyValue,
        toCurrencyValue,
        codeValue,
    } as Record<string, string>;
};

export const getListsCurrency = (list: TConsumerItem[]) => {
    const result: TResult = {
        fromCurrencyList: [],
        toCurrencyList: [],
    };
    if (list && Array.isArray(list) && list.length > 0) {
        return list.reduce((acc: typeof result, item: TConsumerItem) => {
            if (item.from) {
                acc.fromCurrencyList.push(item);
            }
            if (item.to) {
                acc.toCurrencyList.push(item);
            }
            return acc;
        }, result);
    }
    return result;
};
export const getCurrency = (value: string, list: TConsumerItem[]) => {
    const defaultResult = {
        currency: undefined,
        currencyIndex: 0,
        isDisabled: false,
    };
    if (value && list && Array.isArray(list) && list.length > 0) {
        const currencyIndex = list.findIndex((currency) => {
            if (currency && typeof currency.value === 'string') {
                return currency?.value?.toLowerCase() === value.toLowerCase();
            }
            return defaultResult;
        });
        if (currencyIndex !== -1) {
            return {
                currency: list[currencyIndex],
                isDisabled: list.length === 1,
                currencyIndex,
            };
        }
        return defaultResult;
    }
    return defaultResult;
};

export const getErrors = (errors: TCalculatorError[]) => {
    const result = {
        fromInput: undefined,
        toInput: undefined,
        code: undefined,
    };
    if (errors.length > 0) {
        return errors.reduce((acc: TErrorsResult, error: TCalculatorError) => {
            if (error.field === ECalculatorErrorField.FROM) {
                acc.fromInput = error;
            } else if (error.field === ECalculatorErrorField.TO) {
                acc.toInput = error;
            } else if (error.field === ECalculatorErrorField.CODE) {
                acc.code = error;
            }
            return acc;
        }, result);
    }
    return result;
};
export const getTopUpError = (errors: TCalculatorError[]) => {
    const defaultResult = {} as TCalculatorError;
    if (errors.length > 0) {
        const error = errors.find((error) => error && error.type);
        if (error) {
            return error;
        }
        return defaultResult;
    }
    return defaultResult;
};

export const getWaitFor = (actions?: TWAction[], defaultDelay = 500): number => {
    if (actions) {
        const action = actions?.find((a) => a?.name === ActionNameEnum.onCalculate);
        if (action && action.delay) {
            return action.delay;
        }
        return defaultDelay;
    }
    return defaultDelay;
};

export const isCanDoRequest = (value?: string, action?: TWAction) => {
    const isValueEndsSeparator = value?.endsWith('.');
    return action && value && value !== '0' && !isValueEndsSeparator;
};
